// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {CharacterRect} from '../search-index/character-rect.js'
import {SeqId} from '../seq-id.js'

export class HandwritingDataPerPage {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): HandwritingDataPerPage {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsHandwritingDataPerPage(
    bb: flatbuffers.ByteBuffer,
    obj?: HandwritingDataPerPage
  ): HandwritingDataPerPage {
    return (obj || new HandwritingDataPerPage()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsHandwritingDataPerPage(
    bb: flatbuffers.ByteBuffer,
    obj?: HandwritingDataPerPage
  ): HandwritingDataPerPage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new HandwritingDataPerPage()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  pageId(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  text(): string | null
  text(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  text(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  characterRects(index: number, obj?: CharacterRect): CharacterRect | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset
      ? (obj || new CharacterRect()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!)
      : null
  }

  characterRectsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  sha256Hash(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0
  }

  sha256HashLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  sha256HashArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset)
        )
      : null
  }

  static startHandwritingDataPerPage(builder: flatbuffers.Builder) {
    builder.startObject(4)
  }

  static addPageId(builder: flatbuffers.Builder, pageIdOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, pageIdOffset, 0)
  }

  static addText(builder: flatbuffers.Builder, textOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, textOffset, 0)
  }

  static addCharacterRects(builder: flatbuffers.Builder, characterRectsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, characterRectsOffset, 0)
  }

  static startCharacterRectsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 2)
  }

  static addSha256Hash(builder: flatbuffers.Builder, sha256HashOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, sha256HashOffset, 0)
  }

  static createSha256HashVector(builder: flatbuffers.Builder, data: number[] | Uint8Array): flatbuffers.Offset {
    builder.startVector(1, data.length, 1)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!)
    }
    return builder.endVector()
  }

  static startSha256HashVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1)
  }

  static endHandwritingDataPerPage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // page_id
    builder.requiredField(offset, 6) // text
    builder.requiredField(offset, 8) // character_rects
    builder.requiredField(offset, 10) // sha256_hash
    return offset
  }

  static createHandwritingDataPerPage(
    builder: flatbuffers.Builder,
    pageIdOffset: flatbuffers.Offset,
    textOffset: flatbuffers.Offset,
    characterRectsOffset: flatbuffers.Offset,
    sha256HashOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    HandwritingDataPerPage.startHandwritingDataPerPage(builder)
    HandwritingDataPerPage.addPageId(builder, pageIdOffset)
    HandwritingDataPerPage.addText(builder, textOffset)
    HandwritingDataPerPage.addCharacterRects(builder, characterRectsOffset)
    HandwritingDataPerPage.addSha256Hash(builder, sha256HashOffset)
    return HandwritingDataPerPage.endHandwritingDataPerPage(builder)
  }
}
